// extracted by mini-css-extract-plugin
module.exports = {"modalbody":"CustomModal_modalbody__1_QYP","close-btn":"CustomModal_close-btn__259L4"};